<template>
    <base-filter
        :status-options="statuses"
        :date-mode="'range'"
        :show-team-members="true"
        :show-carriers="true"
        :show-customer-filter="true"
        :show-time-window="true"
        :show-driver-rating="true"
        :show-blank-date-toggle="true"
        :clearable="false"
        :team-region-id="teamRegionId"
        :initial-filters="initialFilters"
        :status-test-id="'stop-status'"
        :from-date-test-id="'start-date'"
        :to-date-test-id="'end-date'"
        :default-status="'Active'"
        :time-window-filter-options="timeWindowFilterOptions"
        :is-geocoded-view="isGeocodedView"
        :blank-date-label="'Show stops with no date first'"
        domain="stops"
        @onFilterStops="handleFilterStops"
    ></base-filter>
</template>
<script>
import { BaseFilter } from '@/components';
import { STATUS_CONSTANTS } from '@/utils/constants';
import { titleCase } from '@/helpers';

export default {
    name: 'FilterComponent',
    components: { BaseFilter },
    props: {
        teamRegionId: {
            type: Number,
            default: null
        },
        teamMembers: {
            type: Function,
            default: () => []
        },
        timeWindowFilterOptions: {
            type: Array,
            default: () => []
        },
        isGeocodedView: {
            type: Boolean,
            default: false
        },
        filterValue: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            statuses: ['Active', ...STATUS_CONSTANTS, 'All'],
            initialFilters: {
                status: 'Active',
                teamMemberPublicUserId: '',
                carrierTeamId: null,
                teamRegionId: null,
                customerId: null,
                fromDate: null,
                toDate: null,
                timeWindowStart: null,
                timeWindowEnd: null,
                driverRating: null,
                showBlankDateFirst: false
            }
        };
    },
    watch: {
        filterValue: {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    this.handleFilterSetValue();
                }
            }
        }
    },
    methods: {
        handleFilterStops(payload) {
            this.$emit('onFilterStops', payload);
        },
        handleFilterSetValue() {
            if (!this.filterValue) {
                return;
            }

            const updates = {};

            if (this.filterValue.fromDate) {
                updates.fromDate = this.filterValue.fromDate;
            }

            if (this.filterValue.toDate) {
                updates.toDate = this.filterValue.toDate;
            }

            if (this.filterValue.status) {
                updates.status = titleCase(this.filterValue.status);
            }

            if (this.filterValue.teamMemberPublicUserId) {
                updates.teamMemberPublicUserId = this.filterValue.teamMemberPublicUserId;
            }

            if (this.filterValue.teamRegionId) {
                updates.teamRegionId = Number(this.filterValue.teamRegionId);
            }

            if (this.filterValue.customerId) {
                updates.customerId = Number(this.filterValue.customerId);
            }

            if (this.filterValue.showBlankStopDateFirst === 'true') {
                updates.showBlankDateFirst = true;
            }

            if (this.filterValue.driverRating) {
                updates.driverRating = Number(this.filterValue.driverRating);
            }

            this.initialFilters = {
                ...this.initialFilters,
                ...updates
            };
        },
        clearFilters() {
            this.initialFilters = {
                status: 'Active',
                teamMemberPublicUserId: '',
                carrierTeamId: null,
                teamRegionId: null,
                customerId: null,
                fromDate: null,
                toDate: null,
                timeWindowStart: null,
                timeWindowEnd: null,
                driverRating: null,
                showBlankDateFirst: false
            };
        }
    }
};
</script>

<style lang="scss" scoped>
.filter-steps--container {
    ::v-deep .md-field,
    ::v-deep .filter-item {
        display: inline-block;
        width: 200px;
        margin-right: 20px;
        margin-top: 0;
        vertical-align: top;
    }

    ::v-deep .filter-item--checkbox {
        white-space: nowrap;
    }

    ::v-deep .filter-item--checkbox label {
        white-space: nowrap;
    }
}
</style>
